import { throwError as observableThrowError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClient } from "../../shared/services/http/http-client.service";

@Injectable()
export class ProductQualificationService {
  constructor(private _http: HttpClient) {}

  create(productQualification: any) {
    return this._http.post("/api/productqualification/create", productQualification).pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) =>
        observableThrowError(error.message || "Server product qualification creation error")
      )
    );
  }

  list(showSpinner: boolean = true) {
    return this._http.get("/api/productqualification/list", showSpinner).pipe(
      map((res: any) => res),
      catchError((error: any) =>
        observableThrowError(error.message || "Server product qualification list error")
      )
    );
  }

  update(productQualification: any) {
    return this._http.patch("/api/productqualification/update", productQualification).pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) =>
        observableThrowError(error.message || "Server product qualification update error")
      )
    );
  }

  delete(id: string) {
    return this._http.delete("/api/productqualification/delete/" + id).pipe(
      map((res) => {
        return res;
      }),
      catchError((error: any) =>
        observableThrowError(error.message || "Server product qualification delete error")
      )
    );
  }
}
